import _ from 'lodash'
import React, { Component } from 'react'
import { TouchableOpacity } from 'react-native'
import dayjs from 'dayjs'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { getSelectedStore } from 'x/redux/selectors'
import * as StoreState from 'x/modules/store/StoreState'

import {
  IOrderListFilterPreference,
  ILineLonRemarkTemplateItem,
  IOrderLineLonRemarkTemplateSelectorProps,
  IOrderLineLonRemarkTemplateSelectorState,
} from 'x/index'
import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as util from 'x/utils/util'
import * as NavActions from 'x/utils/navigation'
import * as api from 'x/utils/api'

import HStack from '../HStack'
import VStack from '../VStack'
import XText from '../XText'
import XCustomHeader from '../XCustomHeader'
import Box from '../Box'
import XCard from '../XCard'
import XOverlay from '../XOverlay'
import XContent from '../XContent'
import XButton from '../XButton'
import ForwardIcon from '../ForwardIcon'
import XIcon from '../XIcon'

export class OrderLineLonRemarkTemplateSelectorBase extends Component<
  IOrderLineLonRemarkTemplateSelectorProps,
  IOrderLineLonRemarkTemplateSelectorState
> {
  static displayName = 'OrderLineLonRemarkTemplateSelector'

  inProcess?: boolean

  constructor(props) {
    super(props)

    this.state = {
      templateItems: [],
      isInitialized: false,
      isModalVisible: false,
    }
  }

  async componentDidMount(): Promise<void> {
    // // Normalized selectedTemplate first time
    // const { selectedTemplate } = this.props
    // const isSelectable = this._isSelectable()
    // if (isSelectable && selectedTemplate && selectedTemplate.id) {
    //   this._onSelectFilterTemplate(selectedTemplate)
    //   await util.delay(50)
    // }
    this.setState({ isInitialized: true })
  }

  _fetchTemplateList = async () => {
    const { storeId } = this.props

    try {
      const tmpls = await api.GetLineLonRemarkTemplateList({ store_id: storeId })
      console.log('Fetched LineLon Remark Templates: ', tmpls)
      this.setState({ templateItems: tmpls })
    } catch (error) {
      console.log('Error fetching LineLon Remark Templates: ', error)
    }
  }

  // _getPref = (): IOrderListFilterPreference => util.getOrderListFilterPreferance()

  // _isSelectable = () => {
  //   const { onSelect } = this.props
  //   return _.isFunction(onSelect)
  // }

  _onSelectFilterTemplate = (tmpl: ILineLonRemarkTemplateItem, isSelected?: boolean) => {
    if (this.inProcess) {
      return
    }
    this.inProcess = true

    const { onSelect } = this.props

    if (_.isFunction(onSelect)) {
      onSelect(tmpl)
      // if (isSelected) {
      //   onSelect(null)
      // } else {
      //   const nTmpl = this._getNormalizeFilterTemplate(tmpl)
      //   onSelect(nTmpl)
      // }
    }

    // if (isSelected) {
    //   await this.resetToDefaultSetting()
    //   await this.resetSelectedTemplate()
    //   p.op.showToast('เลิกใช้งานนเทมเพลตตัวกรองออเดอร์', 'success')
    // } else {
    //   const nTmpl = this._getNormalizeFilterTemplate(tmpl)
    //   await util.setStatePromise(this, { selectedTemplate: nTmpl })
    //   await this.updateNewSetting(nTmpl)
    //   p.op.showToast('ใช้งานเทมเพลตตัวกรองออเดอร์แล้ว', 'success')
    // }

    this.inProcess = false
    this._closeFilterTemplateSelectorModal()
  }

  _clearSelect = () => {
    const { selectedTemplate } = this.props
    this._onSelectFilterTemplate(selectedTemplate, true)
  }

  _navToCreateFilterTemplate = async () => {
    this._closeFilterTemplateSelectorModal()
    await util.delay(100)

    const { navigation, selectedStore } = this.props

    const newTemplate: ILineLonRemarkTemplateItem = {
      id: `${dayjs().format('YYYYMMDD').toString()}x${util.generateRandomString(5)}`,
      name: '',
      createdAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
      updatedAt: dayjs().format(CONS.SERVER_DATETIME_FORMAT).toString(),
      color: '#b79ec7',
    }

    navigation.dispatch(
      NavActions.navToOrderListFilterEditorView({
        headerTitle: 'สร้างเทมเพลตตัวกรองออเดอร์',
        store_id: selectedStore.get('id'),
        defaultSetting: newTemplate,
        appliedSetting: newTemplate,
        // onSaveSuccess: this._onEditFilterSaveSuccess,
      })
    )
  }

  open = async () => {
    await this._fetchTemplateList()
    await util.delay(100)
    this._openFilterTemplateSelectorModal()
  }

  _openFilterTemplateSelectorModal = () => {
    // const pref = this._getPref()
    // const { templates } = pref
    // if (!templates || templates.length === 0) {
    //   p.op.alert('ยังไม่มีเทมเพลตตัวกรองออเดอร์', 'กรุณาปรับตัวกรอง และกดเพิ่มเทมเพลตตัวกรองออเดอร์ จากปุ่มบันทึกในแถบด้านบนด้านขวามือ')
    //   return
    // }

    this.setState({ isModalVisible: true })
  }

  _closeFilterTemplateSelectorModal = () => {
    const { onSelectorModalRequestClose } = this.props
    this.setState({ isModalVisible: false })
  }

  _renderLineLonTemplateItem = (tmpl: ILineLonRemarkTemplateItem, index: number) => {
    const { selectedTemplate } = this.props
    const isSelected = selectedTemplate && selectedTemplate.id === tmpl.id

    return (
      <TouchableOpacity key={`filter-tmpl-${index}`} onPress={() => this._onSelectFilterTemplate(tmpl, isSelected)}>
        <HStack
          // key={`filter-tmpl-content-${index}`}
          w='full'
          minH='34px'
          p='2'
          space='2'
          bg={isSelected ? 'primary.50' : 'white'}
          borderWidth='1'
          borderColor={tmpl && tmpl.label_color ? tmpl.label_color : 'gray.400'}
          borderRadius='lg'
          alignItems='center'
        >
          <Box w='20px' h='20px' borderRadius='full' bg={tmpl.label_color} />

          <VStack flex={1}>
            <XText
              color={tmpl.label_color}
              // make text shadow for better visibility
              style={{ textShadowColor: 'rgba(0, 0, 0, 0.3)', textShadowOffset: { width: 0, height: 1 }, textShadowRadius: 1 }}
            >
              {tmpl.label_text}
            </XText>

            <HStack w='full' flexWrap='wrap'>
              <XText numberOfLines={3} variant='inactive'>
                {tmpl.remark}
              </XText>
            </HStack>
          </VStack>

          <HStack w='40px' justifyContent='flex-end' alignItems='center'>
            {isSelected ? <XIcon name='checkmark-circle' family='Ionicons' variant='success' /> : <ForwardIcon />}
          </HStack>
        </HStack>
      </TouchableOpacity>
    )
  }

  _renderEmptyTemplateText = () => (
    <HStack w='full' px='2' py='4' alignItems='center' justifyContent='center'>
      <XText variant='inactive' textAlign='center'>
        {'คุณสามารถสร้าง "เทมเพลตตัวกรองออเดอร์"\nเพื่อ *บันทึกตัวเลือกการกรอง* ไว้ใช้งานในภายหลังได้\n\n' +
          'กดปุ่ม "สร้างเทมเพลตใหม่" ด้านล่าง เพื่อสร้าง'}
      </XText>
    </HStack>
  )

  _renderLineLonTemplateItems = () => {
    // const pref = this._getPref()
    // const { templates = [] } = pref

    // if (!templates || templates.length === 0) {
    //   return this._renderEmptyTemplateText()
    // }

    // return templates.map(this._renderLineLonTemplateItem)

    const { templateItems } = this.state

    if (!templateItems || templateItems.length === 0) {
      return this._renderEmptyTemplateText()
    }

    return templateItems.map(this._renderLineLonTemplateItem)
  }

  _renderFilterTemplateSelectorModal = () => {
    const { isSelectorModalShow, selectedTemplate } = this.props
    const { isModalVisible } = this.state

    const isShow = isSelectorModalShow || isModalVisible
    if (!isShow) {
      return null
    }

    return (
      <XOverlay visible onRequestClose={this._closeFilterTemplateSelectorModal}>
        <XCustomHeader
          title='เลือกเทมเพลต LINE LON Remark'
          // headerRightProps={{ closeIcon: true, onPressItem: this._closeFilterTemplateSelectorModal }}
          // headerRightProps={{ settingIcon: true, onPressItem: this._navToOrderListFilterManageView }}
        />
        <XContent flex={p.op.isWeb() ? 1 : 0} minH='350px' maxH='800px'>
          <VStack w='full' p='2' space='1.5'>
            {this._renderLineLonTemplateItems()}
          </VStack>
        </XContent>

        {/* <HStack w='full' alignItems='center' justifyContent='center' p='2' space='2'>
          <XButton flex={1} h='34px' variant='outline' onPress={this._navToCreateFilterTemplate}>
            สร้างเทมเพลตใหม่
          </XButton>
          <XButton
            disabled={!(selectedTemplate && selectedTemplate.id)}
            w='80px'
            h='34px'
            variant='outline'
            opacity={selectedTemplate && selectedTemplate.id ? 1 : 0}
            onPress={this._clearSelect}
          >
            ล้าง
          </XButton>
          <XButton w='80px' h='34px' variant='outline' onPress={this._closeFilterTemplateSelectorModal}>
            ปิด
          </XButton>
        </HStack> */}
      </XOverlay>
    )
  }

  render() {
    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    return this._renderFilterTemplateSelectorModal()
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
    updateSelectedStoreByKey: bindActionCreators(StoreState.updateSelectedStoreByKey, dispatch),
  }),
  null, // mergeProps (optional)
  { forwardRef: true } // Key option here
)(OrderLineLonRemarkTemplateSelectorBase)
// as React.FC<Omit<IOrderLineLonRemarkTemplateSelectorProps, 'selectedStore' | 'updateSelectedStoreByKey'>>
